const translations = {
    flow: 'Flow',
    level: 'Level',
    magnetometer: 'Magnetometer',
    noCalibrationKindsFound: 'No calibration types found.',
    pump: 'Pump',
    search: 'Search',
    weight: 'Weight'
};

export default translations;
